import makeCloudinaryUrlForPhoto from '../afa-photo'
import cloudinary from 'cloudinary-core'

var cl = cloudinary.Cloudinary.new({cloud_name: 'dgps1radv', secure: true});


function makeCloudinaryUrlForPhotoWithAfaPuppetCloud (photo, opts={}) {
  if (opts.cloud_name) {
    cl.config("cloud_name", opts.cloud_name)
    photo = photo || {}
    let {url, alt, type, pid} = photo
    let {width, height} = opts
    let clType = 'fetch'
    if (type === 'cl') {
      clType = null
      url = pid
    }
    if (!url) {return 'no-pic'} // if no image is associated with product
    let src = cl.url(url,
      {width: Number(width || 50), crop: "fill",  type: clType})
    return src
  }

  return makeCloudinaryUrlForPhoto(photo, opts)
}

// function makeCloudinaryUrlForPhoto (photo, opts={}) {
//   // console.log(opts)
//   if (opts.cloud_name) {
//     cl.config("cloud_name", opts.cloud_name)
//   }

  // photo = photo || {}
  // let {url, alt, type, pid} = photo
  // let {width, height} = opts
  // let clType = 'fetch'
  // if (type === 'cl') {
  //   clType = null
  //   url = pid
  // }
  // if (!url) {return 'no-pic'} // if no image is associated with product
  // let src = cl.url(url,
  //   {width: Number(width || 50), crop: "fill",  type: clType})
  // return src

// }

export default makeCloudinaryUrlForPhotoWithAfaPuppetCloud
